import { Component, OnInit, NgZone } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import * as moment from 'moment/moment';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { FacturationService } from '@app/shared/services/facturation.service';
import { ExcelService } from '@app/shared/services/excel.service';
import { SessionService } from '@app/shared/services/session.service';
import { UsersService } from '@app/shared/services/users.service';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/shared/services/alert.service';

import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from "rxjs/internal/operators";

@Component({
    selector: 'app-gain-list',
    templateUrl: './gain.component.html',
    styleUrls: ['./gain.component.scss']
})
export class GainComponent implements OnInit {
    public month: string = "0";

    public virements: Array<any> = [];

    public virementsSave: Array<any> = [
        {
            courses: [
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R146319",
                    "ISODateEnd": "2022-03-30T19:00:00.0000000Z",
                    "ISODateStart": "2022-03-30T17:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105833,
                    "User": "Maxime Di Nsatal",
                    "Vehicle": "VEHICLE 121"
                },
            ],
            commissions: [
                {
                    "nom": "VOP",
                    "prix": 63,
                    'description': "commission vop",
                },
                {
                    "nom": "Carburant",
                    "prix": 180,
                    'description': "carte total utilisé",
                }
            ],
            adherent: "MOd-eden",
            adherentId: 20,
            reservationsPrix: 63,
            commissionPrix: 240,
            dateDebut: "2022-01-00T21:51:00.0000000Z",
            dateFin: "2022-01-30T21:51:00.0000000Z",
            virementDate: "2022-02-01T21:51:00.0000000Z"
        },
        {
            courses: [
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R146319",
                    "ISODateEnd": "2022-03-30T19:00:00.0000000Z",
                    "ISODateStart": "2022-03-30T17:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105833,
                    "User": "TLastName TFistName",
                    "Vehicle": "VEHICLE 121"
                },
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R146319",
                    "ISODateEnd": "2022-03-30T19:00:00.0000000Z",
                    "ISODateStart": "2022-03-30T12:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105834,
                    "User": "TLastName TFistName",
                    "Vehicle": "VEHICLE 121"
                },
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R010010",
                    "ISODateEnd": "2022-03-30T00:00:00.0000000Z",
                    "ISODateStart": "2022-03-29T22:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105828,
                    "User": "TLastName TFistName",
                    "Vehicle": "FG-509-NH"
                },
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R010011",
                    "ISODateEnd": "2022-03-30T00:00:00.0000000Z",
                    "ISODateStart": "2022-03-29T22:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105829,
                    "User": "TLastName TFistName",
                    "Vehicle": "EN-403-KM"
                },
            ],
            commissions: [
                {
                    "nom": "VOP",
                    "prix": 63,
                    'description': "commission vop",
                },
                {
                    "nom": "Carburant",
                    "prix": 234.3,
                    'description': "carte total utilisé",
                },
                {
                    "nom": "Intervention",
                    "prix": 100,
                    'description': "intervention sur une voiture",
                },
            ],
            adherent: "MODULAUTO",
            adherentId: 20,
            reservationsPrix: 310,
            commissionPrix: 63,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        }, {
            courses: [],
            commissions: [],
            adherent: "MOD-PIC",
            adherentId: 20,
            reservationsPrix: 310,
            commissionPrix: 63,
            dateDebut: "2022-03-00T21:51:00.0000000Z",
            dateFin: "2022-03-30T21:51:00.0000000Z",
            virementDate: "2022-04-01T21:51:00.0000000Z"
        }, {
            courses: [],
            commissions: [],
            adherent: "MOD-PIC",
            adherentId: 20,
            reservationsPrix: 310,
            commissionPrix: 63,
            dateDebut: "2022-03-00T21:51:00.0000000Z",
            dateFin: "2022-03-30T21:51:00.0000000Z",
            virementDate: "2022-04-01T21:51:00.0000000Z"
        }, {
            courses: [],
            commissions: [],
            adherent: "MOD-PIC",
            adherentId: 20,
            reservationsPrix: 310,
            commissionPrix: 63,
            dateDebut: "2022-03-00T21:51:00.0000000Z",
            dateFin: "2022-03-30T21:51:00.0000000Z",
            virementDate: "2022-04-01T21:51:00.0000000Z"
        }, {
            courses: [],
            commissions: [],
            adherent: "MOD-PIC",
            adherentId: 20,
            reservationsPrix: 310,
            commissionPrix: 63,
            dateDebut: "2022-03-00T21:51:00.0000000Z",
            dateFin: "2022-03-30T21:51:00.0000000Z",
            virementDate: "2022-04-01T21:51:00.0000000Z"
        }, {
            courses: [],
            commissions: [],
            adherent: "MOD-PIC",
            adherentId: 20,
            reservationsPrix: 310,
            commissionPrix: 63,
            dateDebut: "2022-03-00T21:51:00.0000000Z",
            dateFin: "2022-03-30T21:51:00.0000000Z",
            virementDate: "2022-04-01T21:51:00.0000000Z"
        }, {
            courses: [],
            commissions: [],
            adherent: "MOD-PIC",
            adherentId: 20,
            reservationsPrix: 310,
            commissionPrix: 63,
            dateDebut: "2022-03-00T21:51:00.0000000Z",
            dateFin: "2022-03-30T21:51:00.0000000Z",
            virementDate: "2022-04-01T21:51:00.0000000Z"
        }, {
            courses: [],
            commissions: [],
            adherent: "MOD-PIC",
            adherentId: 20,
            reservationsPrix: 310,
            commissionPrix: 63,
            dateDebut: "2022-03-00T21:51:00.0000000Z",
            dateFin: "2022-03-30T21:51:00.0000000Z",
            virementDate: "2022-04-01T21:51:00.0000000Z"
        },
    ];


    /* Filters */
    public pickerReservation: any;
    public status: number = 0;
    public search: string = '';
    public searchChanged: Subject<string> = new Subject<string>();
    public societySearch: string = '';

    /* List */
    public reservations: Array<any> = [];
    public comeUp: Array<any> = [];
    public inProgress: Array<any> = [];
    public finished: Array<any> = [];
    public canceled: Array<any> = [];
    public maxPages: number = 1;
    public currentPage: number = 1;
    public loadingStatus: boolean = false;
    public noResult: boolean = false;
    public excelLoading: boolean = false;

    public years: Array<any> = [];
    public selectYear: number = 0;
    public ability: string = "admin" || this.session.role.ability;


    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private reservationService: ReservationsService,
        private excelService: ExcelService,
        private route: ActivatedRoute,
        public session: SessionService,
        private userService: UsersService,
        private alertService: AlertService,
        private facturationService: FacturationService,

        private router: Router,
    ) {
        this.searchChanged
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe(model => {
                this.search = model;
                this.currentPage = 1;
                sessionStorage.setItem('GainFilterSearch', this.search);
                this.updateGain();
            });
    }

    initSearchFilter() {
        this.years = [];
        for (let i = moment().year(); i >= 2015; i--) {
            this.years.push(i.toString());
        }
        this.month = "0";
        this.selectYear = moment().year();
    }

    onSearchChange(search): void {
        this.searchChanged.next(search);
    }

    async updateGain() {
        console.log(this.search)

        this.virements = await this.facturationService.getGain()

        if (this.search.length > 0) {
            this.virements = this.virements.filter(virement => virement.adherent.toLowerCase().includes(this.search.toLowerCase()));
        }

        //month and year filter
        if (this.month !== "0") {
            this.virements = this.virements.filter(virement => moment(virement.virementDate).month().toString() == this.month);
        }

        if (this.selectYear !== 0) {
            this.virements = this.virements.filter(virement => moment(virement.virementDate).year() == this.selectYear);
        }
    }

    onMonthChange(monthId): void {
        console.log("Month", monthId);
        this.month = monthId
        this.updateGain()
    }

    onYearChange(year): void {
        console.log("Year", year);
        this.selectYear = year;
        this.updateGain()
    }

    ngOnInit() {
        this.menu.setMenuState('facturation', 'facturation', 'Auto Facturation');

        this.loadingStatus = true;

        this.getGain()
        this.initSearchFilter();
        // this.route.queryParams
        //     .subscribe(params => {
        //         if (params.vehicule) {
        //             this.search = params.vehicule;
        //             sessionStorage.setItem('ReservationFilterSearch', params.vehicule);
        //             this.updateReservations();
        //         }
        //     });

        this.titleService.setTitle(`Auto Facturation`);
    }

    async getGain() {
        setTimeout(async () => {
            try {
                this.virements = await this.facturationService.getGain()
                this.loadingStatus = false;
                this.calculePrix();
            } catch (error) {

            }
        }, 3000);

        // console.log("gain", await this.facturationService.getGain())
    }

    async calculePrix() {
        for (let virement of this.virements) {
            let prixCommission = 0;
            let prixCourse = 0;

            if (virement.courses && virement.courses.length > 0) {
                for (let i = 0; i < virement.courses.length; i++) {
                    prixCourse += virement.courses[i].prix
                    for (let j = 0; j < virement.courses[i].commissions.length; j++) {
                        prixCommission += virement.courses[i].commissions[j].prix
                    }
                }
            }

            virement.commissionPrix = prixCommission;
            virement.reservationsPrix = prixCourse;
        }
    }


    addCommission(virement): void {
        if (!virement.addCommissionNom) return this.alertService.error('Veuillez entrer un nom pour la commission');
        if (!virement.addCommissionDescription) return this.alertService.error('Veuillez entrer une description pour la commission');
        if (!virement.addCommissionPrix) return this.alertService.error('Veuillez entrer un prix pour la commission');
        if (virement.addCommissionPrix < 0) return this.alertService.error('Le prix de la commission ne peux pas être négatif');

        virement.commissions.push({
            nom: virement.addCommissionNom,
            prix: virement.addCommissionPrix,
            description: virement.addCommissionDescription
        });

        virement.addCommissionNom = '';
        virement.addCommissionDescription = '';
        virement.addCommissionPrix = '';

        this.calculePrix();
    }

    removeCommission(reservation, commission): void {
        console.log(reservation, commission)

        let index = reservation.commissions.indexOf(commission);

        reservation.commissions.splice(index, 1);
        this.calculePrix();
    }

    updateReservations() {
        this.loadingStatus = true;
    }

    nextPage() {
        if (this.currentPage < this.reservationService.maxPages) {
            this.loadingStatus = true;
            this.currentPage += 1;
        }
    }

    goPage(page): any {
        this.loadingStatus = true;
        this.currentPage = page;
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.loadingStatus = true;
            this.currentPage -= 1;
        }
    }

    goToVirement(): void {
        this.router.navigate(['facturation/virements']);
    }

    goToControl(): void {
        this.router.navigate(['facturation/controle']);
    }
}